import { ReactElement, useEffect } from 'react';
import { Box, LinearProgress } from '@mui/material';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatTranslation } from 'intl';
import { ProjectSetupTranslationKeys } from 'intl/keys';
import { ProjectHeading } from './ProjectHeading';
import { contentSx, headlineSx, progressBoxSx, rootSx } from './styles';

export { ProjectLoadingFailed } from './ProjectLoadingFailed';

export function ProjectLoading(): ReactElement {
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    return (): void => {
      if (location.pathname.includes('select-project')) {
        navigate('/issue');
      }
    };
  }, [location.pathname, navigate]);

  return (
    <Box sx={rootSx}>
      <Box sx={contentSx}>
        <ProjectHeading />
        <Box sx={headlineSx}>{formatTranslation(intl, ProjectSetupTranslationKeys.loadingData)}</Box>
        <Box sx={progressBoxSx}>
          <LinearProgress />
        </Box>
      </Box>
    </Box>
  );
}
